import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import { TextArea as StyledTextArea, Label } from './styles'
import { TextAreaData, Html } from './type'

interface Props extends FieldRenderProps<string, HTMLTextAreaElement> {
  id: string
  data: TextAreaData
  html: Html
}


const TextArea: React.FC<Props> = ({
  id,
  input,
  data,
  html,
}) => (
  <>
    <StyledTextArea
      id={id}
      {...input}
      {...html}
    />

    {data.showCounter && (
      <Label
        as="span"
        style={{
          textAlign: 'right',
          fontSize: '12px',
        }}
      >
        {(input.value || '').length}{html.maxLength && `/${html.maxLength}`}
      </Label>
    )}
  </>
)

export default TextArea
